import $ from 'jquery';
/**
 *  Accordion - Class representing a generic accordion.
 */
export default class Accordion {
  constructor() {
    this.bodyRef = $('body').first();
    this.accordionContainerName = 'accordion';
    this.accordions = $(`.${this.accordionContainerName}`);
  }

  /**
   * Initialize accordions on elements with '.accordion' class.
   * In order for accordion to work, data-attribute needs to be added
   * data-accordion-id="ACCORDION_CONTENT_ID"
   * @void
   */
  init() {
    this.accordionAction();
  }

  /**
   * Close Accordion
   */
  closeAccordion() {
    const openedAccordion = this.bodyRef.find('.accordion__content.opened');
    const openedNavbar = this.bodyRef.find('.nav-links.opened');
    const accordionWrapper = this.bodyRef.find('.accordion.active');
    const accordionTrigger = accordionWrapper.find('.accordion__trigger');
    if (accordionTrigger.attr('data-open') !== '') {
      accordionWrapper.each(() => {
        accordionWrapper.removeClass('active');
        openedNavbar.removeClass('opened');
      });
      $('body').removeClass('no-scroll');
      openedAccordion.removeClass('opened');
    }
  }

  /**
   * Register accordion events
   */
  accordionAction() {
    // Close any opened accordion on outside click
    this.bodyRef.on('click', (event) => {
      if (event.target.classList.contains('accordion__trigger')
        || event.target.parentElement?.parentElement.classList.contains('accordion__trigger')) {
        const currentTarget = $(event.target);
        const accordion = $(currentTarget).closest('.accordion');
        const accordionContent = $(`#${accordion.data('accordionId')}`);

        if (accordionContent.length) {
          if (currentTarget.attr('data-open') !== undefined) {
            accordionContent.addClass('opened');
            accordion.addClass('active');
            accordionContent.find('button').each((index, option) => {
              $(option).removeAttr('tabindex');
            });
            return;
          }

          if (currentTarget.attr('data-close') !== undefined) {
            accordionContent.removeClass('opened');
            accordion.removeClass('active');
            $('body').removeClass('no-scroll');
            accordionContent.find('button').each((index, option) => {
              $(option).attr('tabindex', -1);
            });
            return;
          }

          if (currentTarget.attr('data-no-scroll') !== undefined) {
            $('body').toggleClass('no-scroll');
          }

          accordionContent.toggleClass('opened');
          accordion.toggleClass('active');

          // in header navigation only one accordion can be opened
          const accordionsParent = $(accordion).parent();
          if(accordionsParent.hasClass('block-links--nav')) {
            if (accordion.hasClass('active')) {
              accordionsParent.children().each((index, accElement) => {
                const accordion2 = $(accElement);
                if ($(accElement).hasClass('active') && !accordion.is($(accElement))) {
                  $(accElement).removeClass('active');
                  const accordionContent2 = $(`#${accordion2.data('accordionId')}`);
                  accordionContent2.removeClass('opened');
                }
              })
            }
          }

          // prevent focusing elements inside of accordion if accordion is closed
          accordionContent.find('button').each((index, option) => {
            if (accordionContent.hasClass('opened')) {
              $(option).removeAttr('tabindex');
            } else {
              $(option).attr('tabindex', -1);
            }
          });
        }
      }

      if (event.target.parentElement?.classList.contains('accordion__trigger')) {
        const currentTarget = $(event.target);
        if (currentTarget.parent().parent().hasClass('post__actions-dropdown')
          || currentTarget.hasClass('btn') !== true
          || currentTarget.hasClass('show-more')) {
          event.stopPropagation();
        }
        const accordion = $(currentTarget).closest('.accordion');
        const accordionContent = $(`#${accordion.data('accordionId')}`);
        if (accordionContent.length) {
          if (currentTarget.parent().attr('data-open') !== undefined) {
            accordionContent.addClass('opened');
            accordion.addClass('active');

            return;
          }

          if (currentTarget.parent().attr('data-close') !== undefined) {
            accordionContent.removeClass('opened');
            accordion.removeClass('active');
            $('body').removeClass('no-scroll');

            return;
          }

          if (currentTarget.parent().attr('data-no-scroll') !== undefined) {
            $('body').toggleClass('no-scroll');
          }

          accordionContent.toggleClass('opened');
          accordion.toggleClass('active');
          
          // in header navigation only one accordion can be opened
          const accordionsParent = $(accordion).parent();
          if(accordionsParent.hasClass('block-links--nav')) {
            if (accordion.hasClass('active')) {
              accordionsParent.children().each((index, accElement) => {
                const accordion2 = $(accElement);
                if ($(accElement).hasClass('active') && !accordion.is($(accElement))) {
                  $(accElement).removeClass('active');
                  const accordionContent2 = $(`#${accordion2.data('accordionId')}`);
                  accordionContent2.removeClass('opened');
                }
              })
            }
          }

          if (currentTarget.parent().hasClass('sidebar__trigger')) {
            currentTarget.toggleClass('i-hamburger');
            currentTarget.toggleClass('i-close');
            accordion.toggleClass('active');
          }
        }
      }
    });
  }
}
